// Packages
import React, { useEffect, useState, useContext } from "react"
import PropTypes from "prop-types"
import { usePrevious } from "reactHooks"
import classNames from "classnames"
import Modal from "react-modal"
import { StackerContext } from "components/DYStackers/StackerContext"

// Utils
import { addNoScroll, removeNoScroll } from "lib/no-scroll"
// Actions
import {
  createModal,
  toggleModal,
  destroyModal,
} from "components/Stacker/actions/ModalActions"
//import { setAddressFormMode } from "components/Stacker/actions/AddressActions"

// Config
import MC from "components/Stacker/config/ModalConfig"

// Components
import Icon from "components/Stacker/components/Icon/Icon"

// Styles
import "./ModalGeneric.scss"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

function ModalGeneric(props) {
  const dispatch = useDispatch()
  const { LL } = useI18nContext()

  const [visible, setVisible] = useState(props.visible)
  const modalInstanceStatus = useSelector((state) => {
    return state.modal ? state.modal[props.name] : undefined
  })
  const prev_visible = usePrevious(visible)
  const prev_modalInstanceStatus = usePrevious(modalInstanceStatus)

  const {
    standard,
    title = "",
    name,
    message = "",
    children,
    blockFullPage = false,
    additionalClassNames,
    onAfterOpen,
  } = props

  const childrenWithProps = React.Children.map(children, (child) => {
    return React.cloneElement(child, {
      containermodalname: name,
    })
  })

  useEffect(() => {
    dispatch(createModal(props.name))

    if (props.visible) {
      dispatch(toggleModal(props.name, visible))
    }
    return () => {
      dispatch(destroyModal(props.name))
    }
  }, [props.name])

  useEffect(() => {
    const isVisibleChanged = visible !== prev_visible
    if (isVisibleChanged) {
      dispatch(toggleModal(props.name, visible))
    }

    if (modalInstanceStatus !== prev_modalInstanceStatus) {
      if (modalInstanceStatus) {
        addNoScroll()
      } else {
        removeNoScroll()
      }
    }
  }, [visible, modalInstanceStatus])

  function closeModalGeneric() {
    if (typeof props.handleClose === "function") {
      props.handleClose()
    }

    dispatch(toggleModal(props.name, false))
  }

  function handleClose() {
    if (typeof props.handleClose === "function") {
      props.handleClose()
    }
    // if (props.name === MC.MODAL_ADDRESS_OPERATIONS) {
    //   dispatch(setAddressFormMode(""))
    // }
    dispatch(toggleModal(props.name, false))
  }

  const dyStacker = () => {
    const main = document.querySelector("dy-stackers")
    if (main && main.shadowRoot) {
      return main.shadowRoot
    } else if (main) {
      return main
    }
    return document.body
  }

  const stackerContext = useContext(StackerContext)
  const stacker = stackerContext.getInstance()
  const gender = stacker.gender

  return (
    <Modal
      parentSelector={dyStacker}
      isOpen={modalInstanceStatus}
      role="dialog"
      shouldCloseOnOverlayClick={!blockFullPage}
      shouldCloseOnEsc={!blockFullPage}
      ariaHideApp={false}
      onRequestClose={handleClose}
      onAfterOpen={onAfterOpen}
      className={classNames(
        `ModalGeneric animate ${name} ${gender}`,
        {
          "animate-show": modalInstanceStatus,
          "animate-hide": !modalInstanceStatus,
        },
        additionalClassNames
      )}
      aria={
        {
          // labelledby: 'modal-heading' // ,
          // describedby: { describedbyID }
        }
      }
    >
      {standard && (
        <div
          className={classNames("ModalGeneric-header", {
            "p-0": title.length === 0 && message.length === 0,
          })}
        >
          {title.length > 0 && <h2 id="modal-heading">{title}</h2>}
          {message.length > 0 && <p className="message-text">{message}</p>}
        </div>
      )}
      <div className="ModalGeneric-content">{childrenWithProps}</div>
      <button
        className="btn-close"
        onClick={closeModalGeneric}
        aria-label={LL.generic.closeText()}
      >
        <Icon
          additionalClassNames="icon-icon-close"
          iconName="icon-icon-close"
        />
      </button>
    </Modal>
  )
}

ModalGeneric.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  standard: PropTypes.bool,
  visible: PropTypes.bool,
  blockFullPage: PropTypes.bool,
  title: PropTypes.string,
  handleClose: PropTypes.func,
  message: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  additionalClassNames: PropTypes.string,
  onAfterOpen: PropTypes.func,
}

export default ModalGeneric
